import type { EducationLevel, UserPreferences } from '@/types/userPreferences';

const LEVELS: Record<string, EducationLevel> = {
  primary: 'Primary', 'primary-school': 'Primary',
  lower_secondary: 'JHS', 'middle-school': 'JHS',
  upper_secondary: 'SHS', 'high-school': 'SHS',
  tertiary: 'University', university: 'University', adult: 'University',
  Primary: 'Primary', JHS: 'JHS', SHS: 'SHS', University: 'University',
};

/** The RPC stores setup choices in JSONB; older views expose only some fields. */
export function readStudyPreferences(row: Record<string, unknown>): Pick<UserPreferences,
  'education_level' | 'subjects' | 'grade' | 'programme' | 'major' | 'degree_type' | 'country_code' | 'target_exam' | 'study_goal'> {
  const saved = row.preferences && typeof row.preferences === 'object' && !Array.isArray(row.preferences)
    ? row.preferences as Record<string, unknown> : {};
  const stringValue = (...values: unknown[]) => values.find((value): value is string => typeof value === 'string');
  const level = stringValue(saved.education_level, saved.educationLevel, row.education_level);
  const subjects = Array.isArray(saved.subjects) ? saved.subjects : row.subjects;
  return {
    education_level: level ? LEVELS[level] : undefined,
    subjects: Array.isArray(subjects) ? subjects.filter((value): value is string => typeof value === 'string') : [],
    grade: stringValue(saved.grade, row.grade),
    programme: stringValue(saved.programme, row.programme),
    major: stringValue(saved.major, row.major),
    degree_type: stringValue(saved.degree_type, row.degree_type),
    country_code: stringValue(saved.country_code, saved.countryCode, row.country_code),
    target_exam: stringValue(saved.target_exam, saved.targetExam, row.target_exam),
    study_goal: stringValue(saved.study_goal, saved.studyGoal, row.study_goal),
  };
}
